// Standard CriticMarkup additions, deletions, substitutions, and comments.

import type StateInline from '../state-inline'

export default function criticMarkup(
  state: StateInline,
  silent: boolean,
): boolean {
  const start = state.pos
  if (state.src.charCodeAt(start) !== 0x7b /* { */) return false

  const marker = state.src.slice(start + 1, start + 3)
  if (!['++', '--', '~~', '>>'].includes(marker)) return false

  const close = marker === '>>' ? '<<}' : `${marker}}`
  const end = state.src.indexOf(close, start + 3)
  if (end < 0 || end === start + 3) return false

  if (!silent) {
    const content = state.src.slice(start + 3, end)
    if (marker === '>>') {
      const token = state.push('critic_comment', 'span', 0)
      token.content = content
      token.markup = marker
    } else if (marker === '~~') {
      const separator = content.indexOf('~>')
      if (separator <= 0 || separator >= content.length - 2) return false
      const token = state.push('diff_inline', 'span', 0)
      token.content = content
      token.markup = marker
      token.meta = {
        kind: 'update',
        old: content.slice(0, separator),
        new: content.slice(separator + 2),
      }
    } else {
      const token = state.push('diff_inline', 'span', 0)
      token.content = content
      token.markup = marker
      token.meta = { kind: marker === '++' ? 'add' : 'delete' }
    }
  }

  state.pos = end + close.length
  return true
}
